var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-start" },
    [
      _c(
        "el-checkbox",
        _vm._b(
          {
            on: { change: _vm.onChange },
            model: {
              value: _vm.localChecked,
              callback: function ($$v) {
                _vm.localChecked = $$v
              },
              expression: "localChecked",
            },
          },
          "el-checkbox",
          _vm.$attrs,
          false
        ),
        [_vm._v(_vm._s(_vm.label))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }